import { Card } from 'antd';
const VideoCard = ({ id, title, description, urlVideo }) => (
    <Card
        hoverable
        style={{ width: "auto" }}
        cover={
            <video
                controls
                muted
                loop
                src={urlVideo}
                controlsList='nodownload'
                style={{
                    width: "100%",
                    borderRadius: "10px 10px 0 0",
                    objectFit: "cover",
                }}
            />
        }
    >
        <div
            style={{
                padding: "3%",
                textAlign: "justify",
                backgroundColor: "#ffffff",
                borderRadius: "0 0 10px 10px",
            }}
        >
            <h3
                style={{
                    margin: 0,
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "var(--color-primary)",
                    whiteSpace: "normal",
                }}
            >
                {title}
            </h3>
        </div>
    </Card>
);
export default VideoCard;